import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PasskeyState = {
  registered: boolean;
};

const initialState: PasskeyState = { registered: false };

export const { reducer, actions: passkeyActions } = createSlice({
  name: 'passkey',
  initialState,
  reducers: {
    setRegistered(state, action: PayloadAction<boolean>) {
      state.registered = action.payload;
    },
  },
});

export const passkeyRegisteredSelector = (state: { passkey: PasskeyState }) =>
  state.passkey.registered;
